/** Default visible columns in left-to-right display order. */
export const INVITATION_DETAIL_BUILDING_DEFAULT_VISIBLE_KEYS = [
  'name',
  'building_type',
  'phone',
  'billingStreet',
  'email_address',
  'total_of_units',
  'student_housing',
  'detail',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const INVITATION_DETAIL_BUILDING_STORAGE_KEY = 'invitation-detail-properties-v1';
